<template>
  <div>
    <v-dialog
      v-model="viewOrderInvoiceModal"
      persistent
      max-width="820px"
    >
      <v-card
        ref="printArea"
        class="order-invoice-print-root"
      >
        <v-card-text>
          <order-invoice-document
            :invoiceData="invoiceData"
            :companyData="companyData"
            :exRate="exRate"
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            ref="closeBtn"
            style="height:auto"
            outline
            @click="$emit('close')"
          >{{ $t('common.cancel') }}</v-btn>
          <v-btn
            ref="printBtn"
            @click="printInvoice()"
            style="height:auto"
            outline
            color="primary"
          >{{ $t('printLogs.printButton') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import OrderInvoiceDocument from './OrderInvoiceDocument.vue'

export default {
  components: {
    OrderInvoiceDocument
  },

  props: {
    viewOrderInvoiceModal: { default: false },
    companyData: { default: () => ({}) },
    invoiceData: { default: () => ({ customer: {}, orders: [], second_orders: [] }) },
    exRate: { default: 1 }
  },

  methods: {
    printInvoice() {
      // Log the print event (fire-and-forget)
      try {
        const token = localStorage.getItem('access_token')
        const invoiceType = (this.invoiceData.second_orders && this.invoiceData.second_orders.length > 0)
          ? 'second_shipping'
          : 'shipping'
        const totalAmount = this.invoiceData.discount
          ? this.invoiceData.net_price
          : this.invoiceData.total_price
        // Four distinct print contexts share this one component:
        //  - AddOrderInvoice's "Save and view" button: a real invoice was just saved, then
        //    viewed and printed immediately -> is_save_and_view is set, counts as an official
        //    print (is_view_only: false).
        //  - AddOrderInvoice's "Delivery" button: the invoice was just created/updated and
        //    attached to the customer's delivery request -> is_delivery is set, also counts
        //    as an official print, distinguished from Save-and-view in the print log.
        //  - AddOrderInvoice's "View" button: unsaved preview, nothing exists in the DB yet
        //    -> is_preview is set, always view-only.
        //  - Every other caller (orderInvoices.vue, customerOrderInvoices.vue, etc.) opens
        //    this modal purely to look at an already-existing invoice -> neither flag is set,
        //    still view-only since it isn't the invoice's original save-and-print.
        axios.post('api/print-logs', {
          invoice_number: this.invoiceData.invoice_number,
          invoice_type: invoiceType,
          customer_name: this.invoiceData.customer ? this.invoiceData.customer.full_name : '',
          total_amount: totalAmount || 0,
          is_view_only: !this.invoiceData.is_save_and_view && !this.invoiceData.is_delivery,
          is_delivery: !!this.invoiceData.is_delivery
        }, { headers: { Authorization: 'Bearer ' + token } }).catch(() => {})
      } catch (e) { /* silent */ }

      const $root = this.$refs.printArea
        ? $(this.$refs.printArea.$el || this.$refs.printArea)
        : $()
      const $close = this.$refs.closeBtn
        ? $(this.$refs.closeBtn.$el || this.$refs.closeBtn)
        : $()
      const $print = this.$refs.printBtn
        ? $(this.$refs.printBtn.$el || this.$refs.printBtn)
        : $()

      $close.hide()
      $print.hide()
      $('.show-in-print').show()

      if ($root.length) {
        $root.printMe({ path: this.$_print_stylesheet_paths() })
      }

      $close.show()
      $print.show()
      $('.show-in-print').hide()
    },
  },
}
</script>

<style>
.order-invoice-print-root {
  max-width: 850px;
}

.dialog:not(.dialog--fullscreen) {
    max-height: 95%;
}

.modal {
  text-align: center;
  padding: 0 !important;
}

.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-right: -4px;
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}

@media screen and (max-width: 650px) {
  #credit-table-header {
    width: 500px;
    padding-left: 10px;
  }
  #price-section2 {
    width: 500px;
    padding-left: 10px;
    padding-top: 10px;
    font-size: 15px;
  }
  #price-section {
    width: 280px;
  }
  #company-info {
    width: 100%;
  }
  #header-img {
    width: 60px;
    height: 60px;
  }
  .order-invoice-print-root {
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/orderInvoice/viewOrderInvoice.vue